import React, { Component } from "react";
import { List, Button, Toast, Modal,Checkbox} from "antd-mobile";
import { aes } from "lujing-fe-js-encryption";
import { selectNoSignedContractListForTms, signTruckBrokerContractForTms } from "../../../services/author";
import { getPathParams } from "../../../utils/utils";
import styles from "./signAgreement.less";

const Item = List.Item;
export default class SignAgreement extends Component {
  state = {
    driverPartyId: "",
    sourceEnv: null,
    paramObj: {},
    contractDetail: [],
    checkedList:[],
  };

  componentDidMount() {
    if (window.__wxjs_environment === 'miniprogram') {
      this.setState({
        sourceEnv: 'miniprogram',
      });
    }

    const obj = getPathParams(this.props.location.search);
    const { operatorId, ownerPartyId, outUserMobile = '', driverIdCard = '', platformCode } = obj;
    const mobile = outUserMobile.toString();
    const card = driverIdCard.toString();
    let params = {
      platformCode,
      operatorId,
      ownerPartyId,
      outUserMobile: aes.encryption(mobile), //aes.encryption(outUserMobile),
      driverIdCard: aes.encryption(card),//aes.encryption(card),
    }
    this.selectNoSignContractList(params);
    this.setState({ paramObj: obj });
  }

  //查询未签订协议
  selectNoSignContractList(params) {
    const that = this;
    selectNoSignedContractListForTms(params).then(data => {
      if (data.code === 0) {
        const contractDetail = data.data;
        if (contractDetail && contractDetail.length > 0) {
          contractDetail.map((item, index) => {
            item.checked = true;
          });
          that.addToCheckedList(contractDetail);
          // 司机partyId
          let driverPartyId = contractDetail[0].toPartyId;
          that.setState({
            contractDetail,
            driverPartyId,
            paramObj: {
              ...this.state.paramObj,
            }
          })
        }
        if (contractDetail && contractDetail.length == 0) {// 如果已经从别的途径预先签订过协议，则直接跳转结果页
          this.props.history.push("/result?id=1");
        }
      } else {
        Toast.fail(data.msg);
      }
    });
  }

  // 查看合同详情
  handleClick = item => {
    const { contractTemplateCode } = item;
    let lytHost = 'https://lyttest.tf56.com';
    if (!window.location.host.match("test") && !window.location.host.match("localhost")) {
      lytHost = "https://lyt.tf56.com";
    }
    // 兼容小程序端部分机型无法打开word 及 PDF文档
    if (this.state.sourceEnv === 'miniprogram') {
      // 陆运通代收合同
      if (contractTemplateCode === 'TNC8F06376818B87CF') {
        window.open(`${lytHost}/lytMobile/wxCollectionContact.html`, '_self');
        return;
      }
      // 寿光分公司合同详情
      if (item.truckBrokerCompanyCode === 568301945 || item.truckBrokerCompanyCode === 1000000033) {
        window.open(`${lytHost}/lytMobile/wxContactDetail_shouguang.html`, '_self');
        return;
      }
      // 青岛分公司合同详情
      if (item.truckBrokerCompanyCode === 568141757 || item.truckBrokerCompanyCode === 12614022) {
        window.open(`${lytHost}/lytMobile/wxContactDetail.html`, '_self');
        return;
      }
      // 泉州公司合同详情
      if (item.truckBrokerCompanyCode === 568344581 || item.truckBrokerCompanyCode === 1000154510) {
        window.open(`${lytHost}/lytMobile/wxContactDetail_quanzhou.html`, '_self');
        return;
      }
    } else {
      this.props.history.push(
        `/agreementDetail?contractTemplateCode=${contractTemplateCode}`
      );
    }
  };

  checkAddress = (e) => {
    console.log(e);
    const { contractDetail } = this.state;
    contractDetail.forEach((item, index) => {
      if (item.truckBrokerCompanyCode == e.truckBrokerCompanyCode) {
        item.checked = !item.checked;
      }
    })
    this.addToCheckedList(contractDetail);
  }

  addToCheckedList(array){
    let tempArr = [];
    array.forEach((item, index) => {
      if (item.checked == true) {
        tempArr.push(item);
      }
    })
    this.setState({
      checkedList:tempArr,
    })
    console.log('===========', tempArr);
  }

  // 不同意
  handleNo = () => {
    this.props.history.push("/result?id=0");
  };

  // 同意
  handleOk = () => {
    const { driverPartyId, paramObj, checkedList } = this.state;
    if(checkedList.length===0){
       Toast.info('请选择合同');
       return;
    }
    const codes = [];
    checkedList.forEach(i => {
      const {contractList} = i;
      contractList.forEach(j =>{
        codes.push(j.contractTemplateCode);
      })
    });
    const param = {
      platformCode: paramObj.platformCode,
      templetUniqueCodes: codes,
      partyId: driverPartyId,
      truckBrokerCompanyCode: paramObj.truckBrokerCompanyCode,
      key:paramObj.key,
    };
    signTruckBrokerContractForTms(param).then(data => {
      if (data.code === 0) {
        this.props.history.push("/result?id=1");
      } else if (data.code === -10304) {
        // 部分协议签订失败
        Modal.alert(
          '签订失败，请刷新',
          data.msg,
          [
           {text: '取消', style: 'default'},
           { text: '刷新', onPress: () => {
              this.componentDidMount();
           }}
          ])
      }
      else {
        Toast.fail(data.msg);
      }
    });
  };

  render() {
    const { contractDetail } = this.state;
    return (
      <div className={styles.bg}>
        <div className={styles.sign}>
          <div className={styles.text1}>
            感谢您使用陆运通业务模块
          </div>
          <div className={styles.text2}>
            在开展业务前请您仔细阅读并确认《运费确认支付书》、《下游运输供应商》的合同协议内容，点击同意后，开始承接业务。
          </div>
        </div>
        <div className={styles.list}>
          <List className={styles.listItem}>
            {contractDetail && contractDetail.length > 0
              ? contractDetail.map((item, index) => {
                return (
                  <Item>
                    <Checkbox defaultChecked={true} onChange={()=>this.checkAddress(item)} value="companyName"><span className={styles.listCompanyName}>{item.truckBrokerCompanyName}</span></Checkbox>
                    <div>
                      {item.contractList && item.contractList.map((subItem, index) =>{
                         return (<div><List> <Item arrow="horizontal" onClick={() => this.handleClick(subItem)} >《{subItem.contractTemplateName}》</Item></List></div>);
                      })}
                    </div>
                  </Item>
                );
              })
              : null}
          </List>
        </div>
        <div className={styles.bottomView}>
          <Button onClick={this.handleNo} className={styles.btnBlack} style={{lineHeight:'auto'}}>不同意</Button>
          <Button type="primary" onClick={this.handleOk} className={styles.btn}>同意</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/author/contract/signAgreement.js